import { wrap } from 'girder/utilities/PluginUtils';
import { AccessType } from 'girder/constants';
import { restRequest } from 'girder/rest';
import events from 'girder/events';
import ItemListWidget from 'girder/views/widgets/ItemListWidget';
import ItemModel from 'girder/models/ItemModel';
import JobStatusWidget from './widgets/JobStatusWidget';
import JobStatus from 'girder_plugins/jobs/JobStatus';

import '../stylesheets/views/itemList.styl';


//counter to track if all the images uploaded (not large image) are converted to large image.
var counter = 0;
wrap(ItemListWidget, 'render', function (render) {
    const root = this;

    render.call(this);

    function updateAnalysesResources(event) {
        const target = $(event.currentTarget);
        const cid = target.attr('g-item-cid');
        if (target.prop('checked')) {
            this.checked.push(cid);
        } else {
            const idx = this.checked.indexOf(cid);
            if (idx !== -1) {
                this.checked.splice(idx, 1);
            }
        }
        this.trigger('g:checkboxesChanged');
        this.trigger('g:analysesboxesChanged');
    }

    function doNothing(event) {
        // cancels ItemListWidget event's workflow
    }

    function moreInfo(event) {
        event.preventDefault();
        var cid = $(event.currentTarget).attr('g-item-cid');
        this.trigger('g:itemClicked', this.collection.get(cid), event);
    }

    function showJobStatus(event) {
        var jobData = $(event.currentTarget).data() || {};
        var opts = {
            el: $('#g-dialog-container'),
            model: this.parentModel,
            jobData: jobData,
            parentView: this
        };
        this.jobStatusWidget = new JobStatusWidget(opts);
        this.jobStatusWidget.render();
    }

    this.events['change .g-list-checkbox'] = updateAnalysesResources;
    this.events['click .g-item-jobs'] = showJobStatus;
    this.delegateEvents();

    function appendJobStatus(settings) {
        if (!settings || !settings['histomicstk.webroot_path']) {
            return;
        }
        root.$el.find('.g-item-list-entry').each(function () {
            var parent = $(this);
            var cid = $('[g-item-cid]', parent).attr('g-item-cid');
            var item = root.collection.get(cid);
            if (item.has('largeImage')) {
                restRequest({
                    type: 'GET',
                    url: '/item/' + item.id
                }).done((response) => {
                    if (('meta' in response) && ('jobIds' in response.meta)) {
                        var jobIds = response.meta.jobIds.split(',');
                        var jobCounter = 0;
                        var jobDataList = [];
                        jobIds.forEach((jobId) => {
                            jobCounter++;
                            restRequest({
                                type: 'GET',
                                url: '/job/' + jobId.trim()
                            }).done((jobData) => {
                                jobCounter--;
                                if (!jobDataList.some(job => job._id === jobData._id)) {
                                    jobDataList.push(jobData);
                                }
                                if (jobCounter == 0) {
                                    var jobStatus = _.groupBy(jobDataList, job => job.status);
                                    parent.children('.g-item-jobs').remove();
                                    var jobTooltip = ""; "Inactive: "
                                    jobDataList.sort((a, b) => {
                                        return (a.updated > b.updated ? -1 : (a.updated < b.updated ? 1 : 0))
                                    });
                                    var jobStatusRegister = JobStatus.getAll();
                                    for (var i = 0; i < jobStatusRegister.length; i++) {
                                        if (i != 0) { jobTooltip = jobTooltip + " "; }
                                        jobTooltip = jobTooltip + jobStatusRegister[i].text + ": " + (jobStatus[i] ? jobStatus[i].length : 0);
                                    };
                                    var lastJobClass = JobStatus.icon(jobDataList[0].status);
                                    var lastJobColor = JobStatus.color(jobDataList[0].status);
                                    parent.append('<a class="g-item-jobs"><span class="' + lastJobClass + '" style="color:' + lastJobColor + ';"></span></a>');
                                    parent.find('.g-item-jobs').attr({
                                        'title': jobTooltip,
                                        'data-imageName': item.get('name'),
                                        'data-jobData': JSON.stringify(jobDataList)
                                    });
                                }
                            });
                        });
                    }
                });
            }
        });
    }

    function appendWSILink(settings) {
        if (!settings || !settings['histomicstk.webroot_path']) {
            return;
        }
        root.$el.find('.g-item-list-entry').each(function () {
            var parent = $(this);
            var cid = $('[g-item-cid]', parent).attr('g-item-cid');
            var item = root.collection.get(cid);
            var validFileExtensions = ["jpg", "jpeg", "bmp", "gif", "png", "svs", "tif", "vms", "vmu", "ndpi", "scn", "mrxs", "tiff", "svslide", "bif", "qptiff", 'ptif', 'nc', 'ntf', 'nitf'];
            if (item.has('largeImage')) {
                var webroot_path = settings['histomicstk.webroot_path'];
                var itemLink = '/' + webroot_path + '#?image=' + item.id;
                parent.children('.g-item-list-link').attr({
                    'href': itemLink,
                    'target': '_blank'
                });
            } else if (!item["converted"]) {
                item["converted"] = true;
                var isValid = false;
                restRequest({
                    method: 'GET',
                    url: `/item/${item.id}/files`
                }).done((response) => {
                    var itemExt = response[0].exts;
                    isValid = validFileExtensions.some(ext => itemExt.indexOf(ext) >= 0);
                    if (isValid) {
                        counter++;
                        restRequest({
                            method: 'GET',
                            url: `/annotation/item/${item.id}`
                        }).done((annotationResponse) => {
                            restRequest({
                                method: 'POST',
                                url: `/item/${item.id}/tiles`,
                                data: {
                                    fileId: response[0]._id,
                                    notify: true
                                }
                            }).done((response) => {
                                counter--;
                                var webroot_path = settings['histomicstk.webroot_path'];
                                var itemLink = '/' + webroot_path + '#?image=' + item.id;
                                parent.children('.g-item-list-link').attr({
                                    'href': itemLink,
                                    'target': '_blank'
                                });
                                parent.children('.g-item-list-link').children('.large_image_container').remove();
                                parent.children('.g-item-list-link').prepend('<div class="large_image_container"><div class="large_image_thumbnail"><img class="loaded" deferred-src="api/v1/item/' + item.id + '/tiles/thumbnail?width=160&amp;height=100" src="api/v1/item/' + item.id + '/tiles/thumbnail?width=160&amp;height=100"></div></div>');
                                if (annotationResponse.length > 0) {
                                    parent.children('.g-item-list-link').children('.large_image_container').children('.large_image_thumbnail').append('<div class="large_image_annotation_badge" title="' + annotationResponse.length + ' Annotation">' + annotationResponse.length + '</div>');
                                }
                                if (counter == 0) {
                                    delete item["converted"];
                                }
                            });
                        });
                    }
                });
            }
            parent.children('.g-item-more-info').remove();
            parent.append($('<a class="g-item-more-info"><span class="icon-info"></span></a>').attr({
                'href': '/#item/' + item.id,
                'title': 'Open item information',
                'g-item-cid': cid
            }));
        });
    }

    var openImage = $('#g-dialog-container .g-browser-widget').children().length;
    if (!openImage) {
        this.events['click a.g-item-list-link'] = doNothing;
        this.events['click a.g-item-more-info'] = moreInfo;
        this.delegateEvents();

        /* Add WSI Links to each items */
        if (!this._htk_settings) {
            restRequest({
                type: 'GET',
                url: 'HistomicsTK/settings'
            }).done((resp) => {
                this._htk_settings = resp;
                appendWSILink(this._htk_settings);
                appendJobStatus(this._htk_settings);
            });
        } else {
            appendWSILink(this._htk_settings);
            appendJobStatus(this._htk_settings);
        }
    }

    function adjustView(settings) {
        if (!settings || !settings['histomicstk.quarantine_folder']) {
            return;
        }
        root.$el.find('.g-item-list-entry').each(function () {
            var parent = $(this);
            parent.remove('.g-histomicstk-quarantine');
            parent.append($('<a class="g-histomicstk-quarantine"><span>Q</span></a>').attr({
                'g-item-cid': $('[g-item-cid]', parent).attr('g-item-cid'),
                title: 'Move this item to the quarantine folder'
            }));
        });
    }

    function quarantine(event) {
        const target = $(event.currentTarget);
        const cid = target.attr('g-item-cid');
        const item = root.collection.get(cid);
        restRequest({
            type: 'PUT',
            url: 'HistomicsTK/quarantine/' + item.id,
            error: null
        }).done((resp) => {
            events.trigger('g:alert', {
                icon: 'ok',
                text: 'Item quarantined.',
                type: 'success',
                timeout: 4000
            });
            root.trigger('g:changed');
            if (root.parentView && root.parentView.setCurrentModel && root.parentView.parentModel) {
                root.parentView.setCurrentModel(root.parentView.parentModel, {setRoute: false});
            } else {
                target.closest('.g-item-list-entry').remove();
            }
        }).fail((resp) => {
            events.trigger('g:alert', {
                icon: 'cancel',
                text: 'Failed to quarantine item.',
                type: 'danger',
                timeout: 4000
            });
        });
    }

    if (this.accessLevel >= AccessType.WRITE) {
        if (!this._htk_settings) {
            restRequest({
                type: 'GET',
                url: 'HistomicsTK/settings'
            }).done((resp) => {
                this._htk_settings = resp;
                adjustView(this._htk_settings);
            });
        } else {
            adjustView(this._htk_settings);
        }
        this.events['click .g-histomicstk-quarantine'] = quarantine;
        this.delegateEvents();
    }
});



// WEBPACK FOOTER //
// ./plugins/HistomicsTK/web_client/views/itemList.js